var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproachStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 996,
    height: 1077,
    viewBox: "0 0 996 1077",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 523.519,
    y: 855.284,
    width: 543.951,
    height: 543.951,
    rx: 31.4904,
    transform: "rotate(-135.985 523.519 855.284)",
    stroke: "url(#paint0_angular_515_1620)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.873,
    y: 996.33,
    width: 509.279,
    height: 343.865,
    rx: 31.4904,
    transform: "rotate(-135.94 516.873 996.33)",
    stroke: "url(#paint1_angular_515_1620)",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_515_1620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(797.031 1130.88) rotate(-169.481) scale(397.273)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113336,
    stopColor: "#1BF4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9398,
    stopColor: "#002BDC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_515_1620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(773.048 1171.88) rotate(55.844) scale(244.809 359.101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.294502,
    stopColor: "#1BF4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964777,
    stopColor: "#002BDC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproachStep1);
export default __webpack_public_path__ + "static/media/ApproachStep1.2bd3023b75f9f81adec9cc5596e55695.svg";
export { ForwardRef as ReactComponent };